module.exports = __webpack_public_path__ + "static/media/dheya4.1adf1cb8.png";